module.exports = "//static.hsappstatic.net/LoginUI/static-1.13847/img/donut_desktop.svg"